import React from 'react';
import { Link } from 'react-router-dom';
import { asset, tenant } from '../../../config/tenant';
import { whatsappFormatted, whatsappLink, whatsappNumber } from '../whatsapp';
import { PhoneIcon, WhatsAppOutlineIcon } from './icons';
import { SITE_NAV } from './SiteHeader';

interface SiteFooterProps {
	/** rolagem interna (home); sem ele os links apontam para `/#id` */
	scrollTo?: (id: string) => void;
	/** link "Cadastrar-se" / "Cadastre-se" da coluna Acesso */
	registerLabel?: string;
	registerTo?: string;
}

/** Rodapé das páginas públicas. Estilos em HomeRoot (.cr-footer). */
const SiteFooter: React.FC<SiteFooterProps> = ({
	scrollTo,
	registerLabel = 'Cadastre-se',
	registerTo = '/cadastro',
}) => {
	const year = new Date().getFullYear();
	const links = tenant.links;

	const sectionLink = (id: string, label: string) =>
		scrollTo ? (
			<a
				key={id}
				href={`#${id}`}
				onClick={(e) => {
					e.preventDefault();
					scrollTo(id);
				}}
			>
				{label}
			</a>
		) : (
			<Link key={id} to={`/#${id}`}>
				{label}
			</Link>
		);

	return (
		<footer className='cr-footer' id='contato-rodape'>
			<div className='cr-container cr-footer__in'>
				<div className='cr-footer__grid'>
					<div className='cr-footer__brand'>
						<img src={asset('/images/home/logo-branco.png')} alt={tenant.appName} />
						<p>
							Uma plataforma digital para conectar concessionárias e lojistas multimarcas, ampliando o
							acesso a oportunidades e impulsionando negócios.
						</p>
					</div>
					<div className='cr-footer__col'>
						<b>Navegação</b>
						{SITE_NAV.map((item) => sectionLink(item.id, item.label))}
					</div>
					<div className='cr-footer__col'>
						<b>Soluções</b>
						{sectionLink('plataforma', tenant.appName)}
						{links?.avaliadorDigital && (
							<a href={links.avaliadorDigital} target='_blank' rel='noopener noreferrer'>
								Avaliador Digital
							</a>
						)}
					</div>
					<div className='cr-footer__col'>
						<b>Acesso</b>
						<Link to={registerTo}>{registerLabel}</Link>
						{sectionLink('login', 'Acessar Plataforma')}
						{links?.forgotPassword && (
							<a href={links.forgotPassword} target='_blank' rel='noopener noreferrer'>
								Recuperar Senha
							</a>
						)}
					</div>
					<div className='cr-footer__col'>
						<b>Contato</b>
						<a href={`tel:+${whatsappNumber()}`}>
							<PhoneIcon />
							{whatsappFormatted()}
						</a>
						<a href={`mailto:${tenant.contacts.email}`}>{tenant.contacts.email}</a>
						<a href={whatsappLink()} target='_blank' rel='noopener noreferrer'>
							<WhatsAppOutlineIcon />
							Atendimento via WhatsApp
						</a>
					</div>
				</div>
				<div className='cr-footer__bottom'>
					<span>
						© {year} {tenant.appName}. Todos os direitos reservados.
					</span>
					{(links?.privacyPolicy || links?.termsOfUse) && (
						<span className='cr-footer__legal'>
							{links?.privacyPolicy && (
								<a href={links.privacyPolicy} target='_blank' rel='noopener noreferrer'>
									Política de Privacidade
								</a>
							)}
							{links?.privacyPolicy && links?.termsOfUse && <i aria-hidden='true'>|</i>}
							{links?.termsOfUse && (
								<a href={links.termsOfUse} target='_blank' rel='noopener noreferrer'>
									Termos de Uso
								</a>
							)}
						</span>
					)}
				</div>
			</div>
		</footer>
	);
};

export default SiteFooter;
